<script>
	export let index;
	let used = index; // To silence the "Empty has unused export property 'index'" notice during compilation.
</script>